import {SectionItem} from 'common/components/items-menu/types';
import {FilterSelectConfig} from 'common/components/filter-bar/types';
import {Translatable} from 'common/i18n';

export function getItemValue(item: SectionItem): Translatable {
  // TODO: update callsites to specify `value` rather than using `label` for the item's value
  return item.value ?? item.label;
}

export function getConfigDefaultValue(config: Omit<FilterSelectConfig, `sections`>): string {
  return config.defaultFilterValue ?? config.defaultFilterLabel;
}
